export default "__VITE_ASSET__8db31f5c__"